import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SharedService } from '../../../core/services/store/shared-store/shared-storage.service';
import { environment } from '../../../../environments/environment';
import { CollectionItem, ReportType } from './collection.model'; 
import { Subject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class CollectionService {

  private static readonly baseApiUri: string = environment.controlBaseUrl + environment.flowManagerBaseUri;
  showToaster = new Subject<any>();
  removeCollection = new Subject<any>();
  collectionAdded = new Subject<any>();

  constructor(
    private http: HttpClient,
    private router: Router,
    private sharedService: SharedService
  ) { }

  private createEntityUri() {
    let finalUrl = CollectionService.baseApiUri;
    const baseUri = [
      this.sharedService.getEnvironment(),
      this.sharedService.getEntityType(),
      this.sharedService.getEntityId(),
    ];
    const newPath = baseUri;

    newPath.forEach((path) => {
      finalUrl = finalUrl.concat('/').concat(path);
    });
    return finalUrl.concat('/config/reporting');
  }

  create(collection: CollectionItem) {
    return this.http.post<Boolean>(`${this.createEntityUri()}`, collection);
  }

  getCollections() {
    return this.http.get(`${this.createEntityUri()}`);
  }

  updateCollection(collection: CollectionItem) {
    return this.http.put<Boolean>(`${this.createEntityUri()}/${collection.featureUUID}`, collection);
  }

  showToast(toastData: any) {
    this.showToaster.next(toastData);
  }

  triggerAddCollection(value: any) {
    this.collectionAdded.next(value);
  }

  getFeatureType(fatureTypeLabel: string) {
    let featureType = '';
    switch(fatureTypeLabel) { 
      case 'Multi Data Points': { 
        featureType = 'FULL'; 
        break; 
      } 
      case 'Start & End Data Points': { 
        featureType = 'SIMPLE';
        break; 
      } 
      case 'Single Data Point': { 
        featureType = 'SINGLE_STEP';
        break; 
      }
    } 
    return featureType;
  }

  removeCollectionCard(cardData: any) {
      this.removeCollection.next(cardData);
  }

}
